module.exports = __webpack_public_path__ + "img/header-engagementRingsSolitaire@2x.7891b43.jpg";